// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

// import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

export function onFormatDate(date: any): any {
    return `${(date.getMonth() + 1)}/${date.getDate()}/${(date.getFullYear() % 100)}`;
}

export function GetDatePickerTranslations() {
    const { t } = useTranslation();
    return {
        months: [
            t('january'),
            t('february'),
            t('march'),
            t('april'),
            t('may'),
            t('june'),
            t('july'),
            t('august'),
            t('september'),
            t('october'),
            t('november'),
            t('december'),

        ],

        shortMonths: [
            t('jan'),
            t('feb'),
            t('mar'),
            t('apr'),
            t('may'),
            t('jun'),
            t('jul'),
            t('aug'),
            t('sep'),
            t('oct'),
            t('nov'),
            t('dec'),
        ],

        days: [
            t('sunday'),
            t('monday'),
            t('tuesday'),
            t('wednesday'),
            t('thursday'),
            t('friday'),
            t('saturday'),
        ],

        shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],

        goToToday: t('go_to_today'),
        prevMonthAriaLabel: t('go_to_previous_month'),
        nextMonthAriaLabel: t('go_to_next_month'),
        prevYearAriaLabel: t('go_to_previous_year'),
        nextYearAriaLabel: t('go_ to_next_year'),
        closeButtonAriaLabel: t('close_date_picker'),
        isRequiredErrorMessage: t('start_date_is_required'),
        invalidInputErrorMessage: t('invalid_date_format'),
    };
}